module.exports = __webpack_public_path__ + "static/img/banner12.30f271d.png";


//////////////////
// WEBPACK FOOTER
// ./static/icon/banner12.png
// module id = tzmm
// module chunks = 0